import AlertBase, { BaseProps } from "."
import { RegistroPagoPendienteOutput } from "src/gql/schema"

interface AlertaProps extends BaseProps {
    registros?: RegistroPagoPendienteOutput[]
}

function Alerta(props: AlertaProps): JSX.Element {
    return (
        <AlertBase
            {...props}
            onConfirm={() => {
                props.onConfirm()
                props.onClose()
            }}
            title={"Hay pagos pendientes"}
            description={
                "Se han detectado uno o más pagos pendientes asociados a este turno.\n¿Deseas continuar con el corte de turno?"
            }
            withCancelOption={true}
            registros={props.registros}
        />
    )
}

export default Alerta
